/*
 * @创建文件时间: 2019-12-21 22:22:26
 * @最后修改人: lfq
 * @最后修改时间: 2020-04-22 20:57:15
 * @联系Qq:1360484677
 * @文件介绍: 应急抢险管理
 */
export default [{
    path: 'erEmergenceDuty',
    name: 'erEmergenceDuty',
    meta: {
        title: '应急值班管理',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erEmergenceDuty')
}, {
    path: 'erEmergenceNews',
    name: 'erEmergenceNews',
    meta: {
        title: '应急新闻发布',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erEmergenceNews')
}, {
    path: 'erEmergenceNotice',
    name: 'erEmergenceNotice',
    meta: {
        title: '应急通知发布',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erEmergenceNotice')
}, {
    path: 'erEmergencePhone',
    name: 'erEmergencePhone',
    meta: {
        title: '应急电话管理',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erEmergencePhone')
}, {
    path: 'erEmergencePlan',
    name: 'erEmergencePlan',
    meta: {
        title: '应急预案管理',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erEmergencePlan')
}, {
    path: 'erResponseFeedback',
    name: 'erResponseFeedback',
    meta: {
        title: '应急响应反馈',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erResponseFeedback')
}, {
    path: 'erWarningFeedback',
    name: 'erWarningFeedback',
    meta: {
        title: '预警信息反馈',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erWarningFeedback')
}, {
    path: 'erEmergencyReport',
    name: 'erEmergencyReport',
    meta: {
        title: '应急事件报送',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erEmergencyReport')
}, {
    path: 'erRequestResource',
    name: 'erRequestResource',
    meta: {
        title: '应急物资征用',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erRequestResource')
}, {
    path: 'erExpressSet',
    name: 'erExpressSet',
    meta: {
        title: '每日快报设置',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erExpressSet')
}, {
    path: 'erExpress',
    name: 'erExpress',
    meta: {
        title: '应急每日快报',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erExpress')
}, {
    path: 'erExpressSum',
    name: 'erExpressSum',
    meta: {
        title: '每日快报汇总',
        auth: true
    },
    component: () =>
        import ('@/views/conserve/emergencyRescue/erExpressSum')
}]